// extracted by mini-css-extract-plugin
module.exports = {"view":"ViewDetails_view__MZR6H","datas":"ViewDetails_datas__2bUuc","datashow":"ViewDetails_datashow__2Ai2J"};